import React from 'react';
import { FolderClosed as LucideFolderClosed } from 'lucide-react';

interface FolderClosedProps {
  width?: number;
  height?: number;
  className?: string;
  style?: React.CSSProperties;
}

const FolderClosed: React.FC<FolderClosedProps> = ({ width = 24, height = 24, className, style }) => (
  <LucideFolderClosed width={width} height={height} className={className} style={style} aria-hidden strokeWidth={2} />
);

export default FolderClosed;
